import * as RestAPI from '../rest_api'

export const fetchPopulationList = () => {
  return new Promise((resolve, reject) => {
    RestAPI.GET('/populations')
      .then((res) => resolve(res))
      .catch((err) => reject(err))
  })
}
